import React from 'react';
import {Icon, WithTooltip} from '@albert-io/atomic';
import type {Placement} from '@albert-io/atomic/molecules/Tooltip/Tooltip.react';

type Props = {
  /** Shown in the tooltip and read as the icon's accessible name. */
  message: string;
  placement?: Placement;
  /**
   * False inside a control that already takes focus, where a second tab stop would nest one
   * interactive element in another. The message still reaches screen readers through the label.
   */
  focusable?: boolean;
};

/** An info icon marking a released FRQ total that does not equal the sum of its rubric scores. */
export default function AdjustedTotalIndicator({
  message,
  placement = 'top',
  focusable = true
}: Props) {
  return (
    <WithTooltip content={message} placement={placement} focusable={focusable} display='flex'>
      <Icon
        aria-label={message}
        color='inherit'
        icon={['far', 'circle-info']}
        data-testid='adjusted-total-indicator'
      />
    </WithTooltip>
  );
}
